<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20.001" height="20.001" viewBox="0 0 20.001 20.001"><path class="tune-a" d="M-1868-6877a10.012,10.012,0,0,1-10-10,10.013,10.013,0,0,1,10-10,10.012,10.012,0,0,1,10,10A10.011,10.011,0,0,1-1868-6877Zm-.336-8v3.5h1.167v-1.167h4.667v-1.167h-4.667V-6885Zm-4.665,1.167v1.167h3.5v-1.167Zm2.333-2.333V-6885h1.165v-3.5h-1.165v1.167H-1873v1.165Zm2.332-1.165v1.165h5.833v-1.165ZM-1866-6892v3.5h1.167v-1.167h2.333v-1.167h-2.333V-6892Zm-7,1.167v1.167h5.831v-1.167Z" transform="translate(1878 6897.001)"/></svg>
</template>

<script>
	export default {
		name: 'tune'
	}
</script>

<style>
	.tune-a {
		fill: #fff;
	}
</style>